/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Result_AbortedInputs */



/**
* | output |
* | --- |
* | "Cancelled before it ran" |
*
* @param {Chat_Tool_Result_AbortedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_aborted = /** @type {((inputs?: Chat_Tool_Result_AbortedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_AbortedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vor der Ausführung abgebrochen")
	return /** @type {LocalizedString} */ ("Cancelled before it ran")
});